"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_SEND_BOX = void 0;
exports["default"] = submitSendBox;
var SUBMIT_SEND_BOX = 'WEB_CHAT/SUBMIT_SEND_BOX';
exports.SUBMIT_SEND_BOX = SUBMIT_SEND_BOX;

function submitSendBox() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'keyboard';

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      channelData = _ref.channelData;

  return {
    type: SUBMIT_SEND_BOX,
    payload: {
      channelData: channelData,
      method: method
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVUJNSVRfU0VORF9CT1giLCJzdWJtaXRTZW5kQm94IiwibWV0aG9kIiwiY2hhbm5lbERhdGEiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N1Ym1pdFNlbmRCb3guanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU1VCTUlUX1NFTkRfQk9YID0gJ1dFQl9DSEFUL1NVQk1JVF9TRU5EX0JPWCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHN1Ym1pdFNlbmRCb3gobWV0aG9kID0gJ2tleWJvYXJkJywgeyBjaGFubmVsRGF0YSB9ID0ge30pIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTVUJNSVRfU0VORF9CT1gsXG4gICAgcGF5bG9hZDogeyBjaGFubmVsRGF0YSwgbWV0aG9kIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU1VCTUlUX1NFTkRfQk9YIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxlQUFlLEdBQUcsMEJBQXhCOzs7QUFFZSxTQUFTQyxhQUFULEdBQWtFO0VBQUEsSUFBM0NDLE1BQTJDLHVFQUFsQyxVQUFrQzs7RUFBQSwrRUFBSixFQUFJO0VBQUEsSUFBcEJDLFdBQW9CLFFBQXBCQSxXQUFvQjs7RUFDL0UsT0FBTztJQUNMQyxJQUFJLEVBQUVKLGVBREQ7SUFFTEssT0FBTyxFQUFFO01BQUVGLFdBQVcsRUFBWEEsV0FBRjtNQUFlRCxNQUFNLEVBQU5BO0lBQWY7RUFGSixDQUFQO0FBSUQifQ==